import React, { useEffect, useState } from 'react';
import Logo from './Logo';
import { NAV_LINKS } from '../data/mock';

const Header = () => {
  const [active, setActive] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
      const sections = NAV_LINKS.map((l) => document.getElementById(l.id)).filter(Boolean);
      const y = window.scrollY + window.innerHeight / 3;
      let current = 'home';
      for (const sec of sections) {
        if (sec.offsetTop <= y) current = sec.id;
      }
      setActive(current);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const goTo = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? 'backdrop-blur-md bg-black/40' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#home" onClick={(e) => goTo(e, 'home')} className="flex items-center gap-2">
          <img
            src="https://customer-assets.emergentagent.com/job_record-studio-hub-1/artifacts/68bxd8p1_logo.png"
            alt="KIUA Music Group"
            className="h-10 md:h-11 w-auto object-contain"
            style={{ filter: 'drop-shadow(0 0 12px rgba(255,40,60,0.45))' }}
          />
        </a>
        <nav className="flex items-center gap-8 md:gap-12">
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              onClick={(e) => goTo(e, link.id)}
              className={`relative text-[12px] md:text-[13px] tracking-[0.25em] font-medium transition-colors duration-300 ${
                active === link.id ? 'text-white' : 'text-white/70 hover:text-white'
              }`}
            >
              {link.label}
              <span
                className={`absolute left-0 -bottom-2 h-[1.5px] bg-white transition-all duration-300 ${
                  active === link.id ? 'w-full' : 'w-0'
                }`}
              />
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
